module.exports = __webpack_public_path__ + "img/Video preview.ee964e11.webp";